__webpack_require__.p = "/api/examples/react-responsive/";